import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LocationManagementComponent } from './pages/location-management/location-management.component';
import { EquipmentManagementComponent } from './pages/equipment-management/equipment-management.component';
import { FileManagementComponent } from './pages/file-management/file-management.component';
import { ScheduleManagementComponent } from './pages/schedule-management/schedule-management.component';
import { DigitalSignageDisplayComponent } from './pages/digital-signage-display/digital-signage-display.component';
import { SignageEditorComponent } from './pages/signage-editor/signage-editor.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { SettingsComponent } from './pages/settings/settings.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'app',
    component: LayoutComponent,
    children: [
      { path: 'dashboard',  component: DashboardComponent },
      { path: 'locations',  component: LocationManagementComponent },
      { path: 'equipment',  component: EquipmentManagementComponent },
      { path: 'files',      component: FileManagementComponent },
      { path: 'schedules',  component: ScheduleManagementComponent },
      { path: 'displays',   component: DigitalSignageDisplayComponent },
      { path: 'editor',     component: SignageEditorComponent },
      { path: 'users',      component: UserManagementComponent },
      { path: 'settings',   component: SettingsComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '',   redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
